// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1aiF9","bigColWidth":"Table_bigColWidth__ls_ld","biggerColWidth":"Table_biggerColWidth__3AUwR","row":"Table_row__2DSkr","col":"Table_col__10hPL"};